<template>
  <div class="login-box">
    <div class="login-main">
      <img src="../../../static/images/bgtwo.png" alt="">
      <div class="login-content">
        <div class="login-content-left">
          <p class="row-line"></p>
          <h1>友盛电梯</h1>
          <p class="content">
            温州友盛电梯工程有限公司于2015年01月04日成立。法定代表人李峰，公司经营范围包括：安装、维修、保养（以上仅限提供上门服务）、
            销售：电梯、自动扶梯、立体停车库及配件（凭有效资质证书经营）；销售：建筑材料、机电产品等。
          </p>
        </div>
        <div class="login-content-right">
          <h2>登录</h2>
          <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login-form">
              <el-form-item prop="username">
                <el-input v-model="ruleForm.username" placeholder="请输入账号">
                  <div slot="prefix" class="slot-div"><img class="slot-img" src="../../../static/images/icons/account.png" alt=""></div>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="ruleForm.password" show-password placeholder="请输入密码">
                  <div slot="prefix" class="slot-div"><img class="slot-img" src="../../../static/images/icons/password.png" alt=""></div>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="checked" class="login-check">两周内自动登录</el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit" class="submit-button">登录</el-button>
              </el-form-item>
            </el-form>
            <div class="visit-web">
              <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备15007702号</a>
              <a href="">访问官网</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="bah" target="_blank" href="https://beian.miit.gov.cn/">备案号：浙ICP备15007702号</a>
  </div>
</template>

<script>
  import { authLogin } from '@/api/Login/index.js'
  import { base64encode } from '@/plugin/base64.js'
  import cookies from '../../libs/util.cookies'
  import { mapState } from 'vuex'
  export default {
    name: 'Login',
    data() {
      return {
        ruleForm: {
          username: '',
          password: ''
        },
        rules: {
          username: [
            { required: true, message: ' ', trigger: 'blur' },
          ],
          password: [
            { required: true, message: ' ', trigger: 'blur' }
          ]
        },
        checked: false
      }
    },
    computed: {
      ...mapState('common/promise', ['beforeName'])
    },
    methods: {
      async onSubmit() {
        const res = await authLogin({
          username: this.ruleForm.username,
          password: base64encode(this.ruleForm.password)
        })
        if (res.code === 200) {
          this.$store.dispatch('common/promise/getPermissions')
          this.$store.dispatch('common/dictionary/setDctByArr')
          this.$store.commit('userStore/user/setUser', res.data.user)
          localStorage.setItem('user', JSON.stringify(res.data.user))
          localStorage.setItem('token', res.data.token)
          cookies.set('token', res.data.token, { expires: 15 })
          this.$router.replace({
            name: this.beforeName ? this.beforeName : 'Index'
          })
        }
      }
    },

  }
</script>

<style lang="scss">
  .login-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(../../../static/images/bgone.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow-y: scroll;
    display: flex;
    align-items: center;
    justify-content: center;
    .login-main {
      width: 1079px;
      position: relative;
      .login-content {
        position: absolute;
        left: 62px;
        top: 62px;
        right: 62px;
        bottom: 62px;
        display: flex;
        .login-content-left {
          flex: 1;
          padding-top: 70px;
          .row-line {
            width: 44px;
            height: 6px;
            background-color: #FFFFFF;
            margin-left: 82px;
          }
          h1 {
            margin: 25px 0;
            margin-left: 76px;
            font-size: 54px;
            font-weight: normal;
            color: #FFFFFF;
          }
          .content {
            font-size: 18px;
            color: #FFFFFF;
            margin-left: 82px;
            margin-right: 56px;
          }
        }
        .login-content-right {
          width: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          h2 {
            font-weight: normal;
            color: #0092ff;
            text-underline: initial;
            font-weight: 600;
            position: relative;
            font-size: 30px;
            margin-bottom: 40px;
            &:after {
              content: ' ';
              position: absolute;
              left: -2px;
              bottom: 0;
              width: 64px;
              height: 6px;
              background-color: rgb(0, 146, 255);
              opacity: 0.302;

            }
          }
          .login-form {
            .el-form-item {
              margin-bottom: 30px;
              width: 300px;

              // .圆角矩形_3_拷贝 {
              //   border-width: 2px;
              //   border-color: rgb(238, 238, 238);
              //   border-style: solid;
              //   position: absolute;
              //   left: 1063px;
              //   top: 443px;
              //   width: 477px;
              //   height: 70px;
              //   z-index: 128;
              // }
              .el-input__inner {
                border-width: 1px;
                border-color: rgb(238, 238, 238);
                border-style: solid;
                height: 50px;
                border-radius: 25px;
                padding-left: 53px;

              }
              .el-form-item__content {
                line-height: 50px;
                display: flex;

                .el-input__prefix {
                  display: flex;
                  align-items: center;
                }
              }
              .submit-button {
                font-size: 18px;
                color: rgb(255, 255, 255);
                line-height: 24px;
                background-color: rgb(0, 118, 254);
                width: 100%;
                border-width: 1px;
                border-color: rgb(0, 118, 254);
                border-style: solid;
                height: 50px;
                border-radius: 25px;
                &:hover {
                  background-color: rgb(0, 118, 254);
                }

              }

            }
            .is-error {
              .el-input__inner {
                border-color: #FA5046;
              }
            }
            .slot-div {
              display: flex;
              align-items: center;
              padding-left: 10px;
            }
            .slot-img {
              width: 22px;
              height: 25px;
              &:first-of-type {
                width: 25px;
              }
            }
            .login-check {
              display: flex;
              align-items: center;
              margin-left: 18px;
              .el-checkbox__inner {
                border-color: rgb(229, 229, 229);
                border-radius: 4px;
                width: 24px;
                height: 24px;
                display: flex;
                &:after {
                  width: 5px;
                  height: 12px;
                }
              }
              .el-checkbox__label {
                display: flex;
                font-size: 16px;
                color: rgb(51, 51, 51);
                font-weight: 600;
              }
            }
          }
          .visit-web{
            display: flex;
            justify-content: space-between;
            width: 300px;
            margin-top: -10px;
            a {
              &:first-child {
                color: #666;
              }
              font-size: 16px;
              color: rgb(0, 118, 254);
              line-height: 24px;
            }
          }

        }
      }
      img {
        height: 700px;
      }
    }
    // .login-main {
    //   position: absolute;
    //   top: 100px;
    //   bottom: 100px;
    //   left: 255px;
    //   right: 255px;
    //   background-color: red;
    //   object-fit: cover;
    //   background-image: url(../../../static/images/bgtwo.png);
    //   background-size: 100% 100%;

    // }
    .bah {
      position: fixed;
      bottom: 20px;
      left: 50%;
      margin-left: 120px;
      color: #111;
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue